import React from 'react'
import Breadcrumb from '../../../../Components/Utils/Breadcrumb'
import { BackButton } from '../../../../Components/Utils/Buttons'
import SchedulesSettings from './Schedule'


function MainCommisioningSetting() {
    return(
        <div className='w-full h-full px-4 py-2'>
          <div className='w-full sm:flex justify-between items-center'>
          <Breadcrumb
            items={[
              {
                name: "Settings",
              },
              {
                name: "Commisioning"
              }
            ]}
          />
          
          <div className='flex justify-end'>
            <BackButton/>
          </div>
          
          </div>
          <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto rounded-md overflow-y-scroll">
                <div className="p-3"><SchedulesSettings/></div>

          </div>
          </div>
      )
}

export default MainCommisioningSetting
